// App-wide refresh registry for the iOS native pull-to-refresh.
//
// Data owners (background photo, weather, prayer times, entitlement) register a
// handler; the native 'refresh' event (see useNativeRefresh) runs them all and
// then tells the host to end the UIRefreshControl spinner. Registration sites
// are gated on isNativeApp(), so on Chrome/Safari this module holds an empty
// set and runAppRefresh is never called — dead code by construction.

export type AppRefreshHandler = () => void | Promise<void>;

const handlers = new Set<AppRefreshHandler>();

/** Register a refresh handler. Returns an unsubscribe function. */
export const onAppRefresh = (handler: AppRefreshHandler): (() => void) => {
  handlers.add(handler);
  return () => {
    handlers.delete(handler);
  };
};

/** Run every registered handler; never rejects (failures are per-handler). */
export const runAppRefresh = async (): Promise<void> => {
  await Promise.allSettled(Array.from(handlers, (h) => Promise.resolve().then(h)));
};
